









helpers = require('../../../helpers.coffee')
on_clickaway = require('vue-clickaway')

view_model = {
  mixins: [ on_clickaway.mixin ]
	components:
		notificationDropdown: require('./dropdown')

	data: ->
    current_user: Session.current_user
    show_notifications_dropdown: false

	computed:
		notifications_count: ->
      @$store.getters.unreadNotificationsCount

	methods:
    readAllNotificationsOnStore: ->
      @$store.commit 'readAllNotifications'

    readAllNotifications: ->
      @notifications_resource.readAll(null, @unknownError)

    toggleNotificationDropdown: ->
      @show_notifications_dropdown = !@show_notifications_dropdown
      if @show_notifications_dropdown
        @readAllNotifications() if @notifications_count > 0
      else
        @readAllNotificationsOnStore() if @notifications_count > 0

    closeNotificationDropdown: ->
      if @show_notifications_dropdown
        @show_notifications_dropdown = false
        @readAllNotificationsOnStore() if @notifications_count > 0

  created: ->
      @notifications_resource = new NotificationsResource()
}

exports.default = helpers.vue_include(view_model)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/notifications/bell.vue